import { selectAllId, WITHOUT_DEPARTMENTS_ID } from 'pages/tasks/constants';
import type { TreeNode } from 'types/interfaces';
import { dateToTimestamp, formatTimestamp } from 'utils/date-utils';
import type { EmployeeAssignmentRulesParams } from 'utils/taskEmployeeAssignmentRules';

export const buildDeptCacheKey = (
  deptId: number,
  showAll: boolean,
  assignmentRulesParams?: EmployeeAssignmentRulesParams | null
) => {
  if (showAll) return `${deptId}-all`;
  const start = assignmentRulesParams?.start ?? '';
  const end = assignmentRulesParams?.end ?? '';
  const effort = assignmentRulesParams?.effort ?? '';
  return `${deptId}-rules-${start}-${end}-${effort}`;
};

export function formatTaskDateCell(raw?: string | number | null): string {
  if (raw === null || raw === undefined || raw === '') return '';
  const s = typeof raw === 'number' ? String(raw) : String(raw).trim();
  if (!s) return '';

  let ms: number | null = null;
  if (s.includes('.') && s.includes(' ')) {
    try {
      const ts = dateToTimestamp(s);
      if (!isNaN(ts)) ms = ts;
    } catch {
      ms = null;
    }
  }
  if (ms === null) {
    const parsed = new Date(s).getTime();
    ms = isNaN(parsed) ? null : parsed;
  }
  return ms === null ? '' : formatTimestamp(ms);
}

export function buildDeptFilterValue(
  selection: TreeNode[],
  treeValue: TreeNode[]
): string {
  if (selection.length === 0) return 'empty';
  const hasSelectAll = selection.some(
    (s) => s.key === selectAllId
  );
  const hasWithout = selection.some((s) => s.key === WITHOUT_DEPARTMENTS_ID);
  if (hasSelectAll) {
    const allLeafKeys = treeValue
      .filter(
        (n) =>
          n.key !== selectAllId &&
          n.key !== WITHOUT_DEPARTMENTS_ID
      )
      .map((n) => String(n.key ?? ''));
    return hasWithout
      ? ['', ...allLeafKeys].join(',')
      : allLeafKeys.join(',');
  }
  return selection
    .map((x) => (x.key === WITHOUT_DEPARTMENTS_ID ? '' : x.key ?? ''))
    .join(',');
}
